// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — rack-state.styled.classic.js, новая — rack-state.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './rack-state.styled.classic';
import * as cp from './rack-state.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
